import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { TraderBuilder } from '../../models/builders/trader-builder';
import { Trader } from '../../models/trader';

const createTraderBody = (trader: Trader) => (
  {
    firstName: trader.firstName,
    lastName: trader.lastName,
    email: trader.email,
    password: trader.password,
    passwordRepeat: trader.passwordRepeat
  }
);

@Injectable()
export class TraderApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}traders`;
  }

  getTrader(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(TraderBuilder.fromJson)
    );
  }

  getTraders() {
    return this.httpClient.get(this.apiUrl).pipe(map(TraderBuilder.fromJsonList));
  }

  createTrader(trader: Trader, file: File) {
    const postBody = new FormData();
    postBody.append('fields', JSON.stringify(createTraderBody(trader)));
    postBody.append('file', (file) ? file : null);

    return this.httpClient.post(`${this.apiUrl}`, postBody).pipe(
      map(TraderBuilder.fromJson)
    );
  }

  updateTrader(trader: Trader, file: File) {
    const putBody = new FormData();
    putBody.append('fields', JSON.stringify(createTraderBody(trader)));
    putBody.append('file', file);

    return this.httpClient.put(`${ this.apiUrl }/${ trader.hash }`, putBody);
  }

  deleteTrader(traderHash: string) {
    return this.httpClient.delete(`${ this.apiUrl }/${ traderHash }`);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/trader-api.service.ts